import { baseApi } from "./baseApi";
import type { MeAccessScopeResponse } from "../../../shared/types/accessScope";

/**
 * The caller's access scope: which communities, groups and departments their
 * filters may offer. Every type comes from shared/types/accessScope.ts.
 */
export type * from "../../../shared/types/accessScope";

export const accessScopeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * `GET /me/access-scope`. Already intersected with the caller's scope on the
     * server, so the client only ever picks inside what this returns.
     */
    getMyAccessScope: builder.query<MeAccessScopeResponse, string>({
      query: (instanceId) => ({ url: "/me/access-scope", params: { instanceId } }),
      // Refreshed by every group, department and user-scope write.
      providesTags: ["AccessScope"],
    }),
  }),
});

export const { useGetMyAccessScopeQuery } = accessScopeApi;
